import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';
import {CardObjeto, Localizacion} from 'lib.front';
import CustomSearch from '../listarClientes/componentes/customSearch';

function FormatoFecha(value) {
   if (value) {
      const fecha = new Date(value);
      return fecha.toLocaleString();
   }
   return '-';
}

// CONFIGURACION TABLA
export const column = [
   {
      name: 'codigo',
      label: 'Código Activación',
      options: {
         sort: false,
         filter: false,
         display: 'excluded'
      }
   },
   {
      name: 'documento',
      label: 'Documento',
      options: {
         sort: false,
         filter: true,
         display: true
      }
   },
   {
      name: 'producto',
      label: 'Producto',
      options: {
         sort: false,
         filter: true,
         display: true
      }
   },
   {
      name: 'anio',
      label: 'Año',
      options: {
         sort: false,
         filter: true,
         display: false
      }
   },
   {
      name: 'fechaRegistro',
      label: 'Registrado el',
      options: {
         sort: false,
         filter: true,
         display: true,
         customBodyRender: value => {
            return FormatoFecha(value);
         }
      }
   },
   {
      name: 'fechaExpiracion',
      label: 'Fecha de expiración',
      options: {
         sort: false,
         filter: true,
         display: true,
         customBodyRender: value => {
            return FormatoFecha(value);
         }
      }
   },
   {
      name: 'usuario',
      label: 'Usuario',
      options: {
         sort: false,
         filter: true,
         display: true,
      }
   },
   {
      name: 'ultimaFechaMod',
      label: 'Modificado el',
      options: {
         sort: false,
         filter: true,
         display: true,
         customBodyRender: value => {
            return FormatoFecha(value);
         }
      }
   },
   {
      name: 'ultimoUsuarioMod',
      label: 'Modificado por',
      options: {
         sort: false,
         filter: true,
         display: true
      }
   },
   {
      name: 'fechaRegistroLicencia',
      label: 'Registrado el',
      options: {
         sort: false,
         filter: false,
         display: 'excluded',
         customBodyRender: value => {
            return FormatoFecha(value);
         }
      }
   }
];

export const configInfoAdicional = [
   
   
   {
      name: 'ide',
      label: 'Ide',
      options: {display: false}
   },
   {
      name: 'mac',
      label: 'Mac',
      options: {display: false}
   },
   {
      name: 'cpu',
      label: 'Cpu',
      options: {display: false}
   },
   {
      name: 'placa',
      label: 'Placa',
      options: {display: false}
   },
   {
      name: 'bios',
      label: 'Bios',
      options: {display: false}
   },
   {
      name: 'sisoper',
      label: 'Sisoper',
      options: {display: false}
   },
   {
      name: 'ram',
      label: 'Ram',
      options: {display: false}
   },
   {
      name: 'chip',
      label: 'Chip',
      options: {display: false}
   },
   {
      name: 'ultimaRazonMod',
      label: 'Razon de modificación',
      options: {display: false}
   }
];

export const options = {
   filterType: 'dropdown',
   selectableRows: 'none',
   responsive: 'standard',
   expandableRows: true,
   expandableRowsHeader: false,
   expandableRowsOnClick: true,
   renderExpandableRow: rowData => {
      const colSpan = rowData.length + 1;
      const infoAdicional = {
         codigo: rowData[0],
         ide: rowData[10],
         mac: rowData[11],
         cpu: rowData[12],
         placa: rowData[13],
         bios: rowData[14],
         sisoper: rowData[15],
         ram: rowData[16],
         chip: rowData[17],
         ultimaRazonMod: rowData[18],
      };
      return (
         <TableRow >
            <TableCell colSpan={colSpan}>
               <CardObjeto
                  value={infoAdicional}
                  configuracion={configInfoAdicional}
                  titulo={`Llave: ${infoAdicional && infoAdicional.codigo}`}
                  style = {{border: '1px solid #C8C8C8', borderRadius: '10px'}}
               />
            </TableCell>
         </TableRow>
      );
   },
   pagination: true,
   elevation: 0,
   rowsPerPage: 3,
   rowsPerPageOptions: [3, 10, 15, 100],
   rowHover: false,
   searchOpen: true,
   search: false,
   print: false,
   download: false,
   viewColumns: true,
   filter: true,
   textLabels: Localizacion.muiDataTables.ES,
   customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
         <CustomSearch searchText={searchText} handleSearch={handleSearch} options={options}/>
      );
   },
};

export const components = {
   icons: {
      ViewColumnIcon: ViewWeekOutlinedIcon
   }
 };
